import { Injectable } from '@angular/core';
import { er } from '@fullcalendar/core/internal-common';
import { da } from 'date-fns/locale';
import { NzUploadFile } from 'ng-zorro-antd/upload';
import { Observable, Subscription, delay, forkJoin, map, of, tap } from 'rxjs';
import { Proposition, Question } from '../interfaces/question.type';
import { QuestionPack } from '../interfaces/questionPack.type';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Buffer } from 'buffer';
// import { randomUUID } from 'crypto';
import { v4 as uuidv4 } from 'uuid';
import { environment } from '../../../environments/environment';

const ADD_QUESTION_API_URL = '/api/v1/quiz/builder/question/addquestion';
const UPDATE_QUESTION_API_URL = '/api/v1/quiz/builder/question/updatequestion/';
const DELETE_QUESTION_API_URL = '/api/v1/quiz/builder/question/deletequestion/';
const GET_QUESTION_API_URL = '/api/v1/quiz/builder/question/getquestions';
const ADD_QUESTION_IMG_API_URL =
  '/api/v1/quiz/builder/question/add-imagequestion';
const DELETE_IMAGE_QUESTION_IMG_API_URL =
  '/api/v1/quiz/builder/question/delete-imagequestion/';

const BASE_URL = environment.BASE_URL;

@Injectable({
  providedIn: 'root',
})
export class QuestionsService {
  questionsPack: any;
  listOfQuestionsPacks: any[];

  packStore = localStorage.getItem('questionsPack');

  constructor(private http: HttpClient) {}

  getCurrentQuestionsPack(): Observable<string | { fileName: any }> {
    try {
      const data = localStorage.getItem('uploadedFiles');
      if (!data) {
  return of(); // Ou une autre action par défaut
}
      const fileName = JSON.parse(data).name;
      // console.log(fileName, data, typeof data, typeof JSON.stringify(data) , typeof JSON.parse(data), JSON.parse(data)[0].name);
      if (fileName) {
        const saveFileData = JSON.parse(localStorage.getItem(fileName));
        return of(saveFileData).pipe(
          delay(100),
          tap((questionData) => {
            this.questionsPack = questionData;
            console.log('les questions recuperer : ', questionData);
          })
        );
      } else {
        return of();
      }
    } catch (error) {
      console.error(error);
    }
  }

  isQuestion(question: any): question is Question {
    return (
      typeof question.questions === 'string' &&
      typeof question.theme === 'string' &&
      Array.isArray(question.proposition) &&
      question.proposition.every(
        (p: any): p is Proposition =>
          typeof p.title === 'string' && typeof p.isCorrect === 'boolean'
      ) &&
      typeof question.difficulte === 'number' &&
      typeof question.typeReponse === 'string' &&
      typeof question.nbreReponse === 'number'
    );
  }

  getQuestionsPackById(id: string): Observable<Question[]> {
    try {
      const data = JSON.parse(localStorage.getItem(id));
      const fileName = data[0].name;
      if (Array.isArray(data) && data.every(this.isQuestion)) {
        return of(data).pipe(
          delay(1500),
          tap((questionData) => {
            this.questionsPack = questionData;
          })
        );
      } else {
        return of(
          data.map((question): Question[] => {
            return {
              ...question,
              reponse: question.reponse.split(','),
              propositions: question.proposition
                .split(',')
                .map((proposition) => {
                  return {
                    title: proposition,
                    isCorrect: false,
                  };
                }),
            };
          })
        ).pipe(
          delay(1500),
          tap((questionData) => {
            this.questionsPack = questionData;
          })
        );
      }
    } catch (error) {
      console.error(error);
    }
  }

  getAllPacksInfo(): Observable<string[] | { fileName: string; data: any }[]> {
    try {
      const data: NzUploadFile[] = JSON.parse(
        localStorage.getItem('questionsPack')
      );

      const allStoredFiles: string[] = data.map((file, index) => file.fileName);
      console.log(' tout les fichiers enregistrés : ', allStoredFiles);

      const storedDataFile = allStoredFiles.map((fileName, index) => {
        const fileNameData = JSON.parse(localStorage.getItem(fileName));
        return {
          fileName: fileName,
          data: fileNameData,
        };
      });

      if (storedDataFile.length > 0) {
        return of(storedDataFile).pipe(
          delay(1000),
          tap((storedQuestions) => {
            this.listOfQuestionsPacks = storedQuestions;
          })
        );
      } else {
        return of([]).pipe(
          delay(1000),
          tap((storedQuestions) => {
            this.listOfQuestionsPacks = storedQuestions;
          })
        );
      }
    } catch (error) {
      console.error(error);
    }
  }

  // Recuperer toutes les vues
  getAllQuestion(
    paginate: boolean = false,
    page: number = 0,
    size: number = 10,
    filters: any = {}
  ): Observable<any> {
    let params = new HttpParams()
      .set('pagination', String(paginate))
      .set('page', String(page))
      .set('size', String(size));

    for (const key in filters) {
      if (filters.hasOwnProperty(key)) {
        params = params.set(key, filters[key]);
      }
    }

    return this.http.get<any>(`${BASE_URL}${GET_QUESTION_API_URL}`, { params });
  }

  // Créer plusieurs questions en meme temps
  createQuestionPack(pack: Question[]): void {
    let data = [];
    const xTAb = ['Question 0', 'Question 2', 'Question 3', 'Question 4'];

    const packStore = localStorage.getItem('questionsPack');
    if (packStore) {
      data = JSON.parse(packStore);
    }
    console.log(pack);

    pack.forEach((question, index) => {
      console.log(
        'Encodage',
        btoa(JSON.stringify(question.proposition)),
        index
      );

      const formDataX = {
        niveauquestionid: question.difficulte,
        categoriequestionid: question.theme?.categoriequestionid,
        quizid: question.quizid,
        enonce: encodeURIComponent(question.enonce),
        proposition: btoa(
          JSON.stringify(
            typeof question.proposition === 'object'
              ? question.proposition.map((proposition) => {
                  return {
                    ...proposition,
                    title: encodeURIComponent(proposition.title),
                  };
                })
              : question.proposition
          )
        ),
        nbrereponsecorrecte: question.nbreReponse
          ? question.nbreReponse
          : question.nbrereponsecorrecte,
        lotquestionname: 'A',
        referenceurl: null,
        point: 10,
        duree: 600,
        status: 'ACTIF',
        // isqcm: false,
      };
      console.log('les formData Generer:', formDataX);

      const formData = new FormData(); // Déplacé à l'intérieur de la fonction interne
      formData.append('questionDtoString', JSON.stringify(formDataX));
      console.log('-------ENVOI---------');

      return this.http
        .post<any>(`${BASE_URL}${ADD_QUESTION_API_URL}`, formData, {
          observe: 'response',
        })
        .subscribe({
          next: (data) => {
            console.log('valeur registered succesfully', data);
          },
          complete() {
            console.log('Succes');
          },
          error(err) {
            console.log(err);
          },
        });
    });
  }

  // Créer une question
  createQuestion(question: Question, images: File[]): Observable<any> {
    const formDataX = {
      niveauquestionid: question.difficulte,
      categoriequestionid: question.theme?.categoriequestionid,
      quizid: question.quizid,
      // enonce: String(question.enonce),
      enonce: encodeURIComponent(question.enonce),
      proposition: btoa(
        JSON.stringify(
          typeof question.proposition === 'object'
            ? question.proposition.map((proposition) => {
                return {
                  ...proposition,
                  title: encodeURIComponent(proposition.title),
                };
              })
            : question.proposition
        )
      ),
      nbrereponsecorrecte: question.nbreReponse
        ? question.nbreReponse
        : question.nbrereponsecorrecte,
      lotquestionname: uuidv4(),
      referenceurl: null,
      point: question.point ,//?? 10,
      duree: question.duree ,//?? 15,
      strictcorrectanswer: false,
      status: 'ACTIF',
    };

    const formData = new FormData(); // Déplacé à l'intérieur de la fonction interne
    formData.append('questionDtoString', JSON.stringify(formDataX));

    if (typeof images === 'object') {
      for (const image of images) {
        formData.append('image', image);
      }
    }

    return this.http.post<any>(`${BASE_URL}${ADD_QUESTION_API_URL}`, formData);
  }

  // createQuestionPack(pack: Question[]): Observable<any> {
  //   let data = [];
  //   const xTAb = ['Question 0', 'Question 2', 'Question 3', 'Question 4'];

  //   const packStore = localStorage.getItem('questionsPack');
  //   if (packStore) {
  //     data = JSON.parse(packStore);
  //   }
  //   console.log(pack);

  //   const calls = [];

  //   return forkJoin(
  //     pack.map((question, index) => {
  //       console.log(
  //         'Encodage',
  //         btoa(JSON.stringify(question.proposition)),
  //         index
  //       );
  //       const formDataX = {
  //         niveauquestionid: question.difficulte,
  //         categoriequestionid: question.theme.categoriequestionid,
  //         quizid: question.quizid,
  //         enonce: question.enonce,
  //         proposition: btoa(JSON.stringify(question.proposition)),
  //         nbrereponsecorrecte: question.nbreReponse,
  //         lotquestionname: 'A',
  //         referenceurl: null,
  //         point: 10,
  //         duree: 600,
  //         status: 'ACTIF',
  //         // isqcm: false,
  //       };

  //       const formData = new FormData();
  //       formData.append('questionDtoString', JSON.stringify(formDataX));
  //       console.log('-------ENVOI---------');

  //       return this.http.post<any>(
  //         `${BASE_URL}${ADD_QUESTION_API_URL}`,
  //         formData,
  //         {
  //           observe: 'response',
  //         }
  //       );
  //     })
  //   );
  // }

  private utf8ToBase64(str: string) {
    // Encode the string as UTF-8
    let utf8Str = new TextEncoder().encode(str);
    // Convert the Uint8Array to a binary string
    let binaryStr = Array.from(utf8Str, (byte) =>
      String.fromCharCode(byte)
    ).join('');
    // Encode the binary string as base64
    return btoa(binaryStr);
  }

  updatePackById(pack: Question, id: number): Observable<any> {
    console.log(pack);
    const data = {
      categoriequestionid: pack.theme ?? pack.categoriequestion.categoriequestionid,
      niveauquestionid: pack.difficulte ?? pack.niveauquestion.niveauquestionid,
      quizid: pack.quiz.quizid,
      enonce: pack.enonce,
      duree: pack.duree ,//10,
      point: pack.point ,// 15,
      nbrereponsecorrecte: pack.nbreReponse,
      referenceurl: null,
      lotquestionname: null,
      proposition: this.utf8ToBase64(JSON.stringify(pack.proposition)),
      status: 'ACTIF',
    };

    console.log('VAleur de formataX ', data, pack);

    return this.http.put<any>(
      `${BASE_URL}${UPDATE_QUESTION_API_URL}${id}`,
      data
    );
  }

  deleteQuestionById(id: number): Observable<any> {
    return this.http
      .delete<any>(`${BASE_URL}${DELETE_QUESTION_API_URL}${id}`)
      .pipe(
        tap({
          next: () => {
            console.log('Suppression effectuer avec succes');
          },
          error: (err) => {
            console.log(err);
          },
        })
      );
  }

  // Add question image
  addImageToQuestion(id: number, url: File): Observable<any> {
    const formData = new FormData();
    formData.append('image', url);
    formData.append('questionid', `${id}`);

    return this.http.post<any>(
      `${BASE_URL}${ADD_QUESTION_IMG_API_URL}`,
      formData
    );
  }

  deleteImageById(id: number): Observable<any> {
    return this.http.delete<any>(
      `${BASE_URL}${DELETE_IMAGE_QUESTION_IMG_API_URL}${id}`
    );
  }
}
